import * as Enumerable from "linq";
import { BaseGhgVerificationRatingFactorClientModel, GhgRatingGroups, GhgVerificationEexiFactorClientModel } from "../../../../../models/ghgs/ghg.models";
import { DataType } from "../../../../../models/queries/queries.models";
import { GhgRatingFactorClientModel } from "../../../../../models/vessels/vessel.models";
import { EditableFieldBinding } from "../../../../components/data-grid/data-grid";
import { BaseGhgFactorsRenderer } from "./base-ghg-factors-renderer";

export class GhgEexiFactorsRenderer extends BaseGhgFactorsRenderer {

    constructor(allEexiFactors: GhgVerificationEexiFactorClientModel[]) {
        super(allEexiFactors);
        this.allFactors.forEach(factor => {
            factor.isVisible = this.showFactor();
        });
    }

    public get orderedFactors(): (BaseGhgVerificationRatingFactorClientModel | GhgRatingFactorClientModel)[] {
        return Enumerable.from(this.allFactors)
            .groupBy(x => x.group)
            .selectMany(x =>
                x.orderBy(x => {
                    if (x.group == GhgRatingGroups.EnginePerformance) {
                        const order = {
                            "MainEngineMcrWithoutEpl": 1,
                            "ShopTestFuelType1Id": 2,
                            "EexiMainSfc": 3,
                            "PilotFuelType1Id": 4,
                            "EexiMainPilotSfc": 5,
                            "Pae": 6,
                            "ShopTestFuelType2Id": 7,
                            "AuxSfc": 8,
                        }
                        return order[x.propertyName];
                    } else {
                        return 0;
                    }
                }))
            .toArray();
    }

    public showGroup() {
        return true;
    }

    public getGroupName(group: string): string {
        if (group == GhgRatingGroups.Speed) {
            return GhgRatingGroups.Speed + " (EEXI)";
        }

        if (group == GhgRatingGroups.EnginePerformance) {
            return "Engine Performance (EEXI)";
        }

        return group;
    }

    public getDisplayName(factor: BaseGhgVerificationRatingFactorClientModel | GhgRatingFactorClientModel) {

        if (!factor) {
            return null;
        }
        if (factor.propertyName == "PowerKwMax") {
            return "Total MCR of all Main Engine(s) (kW; without EPL/ShaPoLi)";
        }
        return factor.displayName;
    }

    public showFactor() {
        return this.showGroup();
    }

    public isFactorReadonly(factor: BaseGhgVerificationRatingFactorClientModel | GhgRatingFactorClientModel): boolean {
        const readonlyProps = ["PowerKwMax", "ShopTestFuelType1Id", "PilotFuelType1Id", "Pae", "ShopTestFuelType2Id", "AuxSfc"];
        return readonlyProps.indexOf(factor.propertyName) > -1;
    }

    public filtersHtml(factor: (BaseGhgVerificationRatingFactorClientModel | GhgRatingFactorClientModel), propValue: string, isEditable: boolean): string {

        const parameterObj = null;
        const secondParameterObj = null;
        const thirdParameterObj = "12";
        const type = factor.dataType;
        let endLabel = "";

        if (factor.propertyName.toLowerCase() == "ReducedMainEngineMcr".toLowerCase() &&
            propValue == "revisedValue" && (isEditable || (<BaseGhgVerificationRatingFactorClientModel>factor).revisedValue)) {
            endLabel = "kW"
        }

        if (factor.propertyName.toLowerCase() == "Speed".toLowerCase() &&
            propValue == "revisedValue" && (isEditable || (<BaseGhgVerificationRatingFactorClientModel>factor).revisedValue)) {
            endLabel = "knots"
        }

        const query = type == DataType.EntityFinder ? 'factor.entityFinderMappedToProperty' : 'factor.lookupMappedToProperty';
        let lookup = null;

        lookup = type == DataType.EntityFinder ? factor.entityFinderMappedToProperty : factor.lookupMappedToProperty;

        const secondParameter = "";

        const binding: EditableFieldBinding = {
            query: query,
            lookup: lookup,
            isEditable: isEditable,
            binding: "factor." + propValue,
            displayValueBinding: "factor." + propValue,
            value: query,
            dataType: type,
            parameter: "factor." + propValue,
            secondParameter: secondParameter,
            isNullable: true,
            buttonDelegate: propValue == "revisedValue" && isEditable ? "ghgEexiFactorsRenderer.onRevisedValueChanged(factor)" : null,
            endLabel: endLabel,
            parameterObj: parameterObj,
            secondParameterObj: secondParameterObj,
            thirdParameterObj: thirdParameterObj,
            isValueCollection: false,
            isPropertyCollection: false,
            isNotRangeDatePicker: true
        };

        return this.getControl(binding, true);
    }
}